import { createApiClient } from '@truecare/api-client';
import { buildSignInRedirect } from './lib/portal-redirect';

/**
 * Phase 14a — admin app API client.
 *
 * baseUrl defaults to empty so requests like `api.GET('/api/v1/admin/dashboard')`
 * go to the same origin. Dev: Vite proxies /api/* to backend at :3000.
 * Production: admin.truecarepartners.ca shares the parent-domain session
 * cookie with portal per 14a-1's BRAND_DOMAIN scope.
 *
 * Audit #17 — on401 is wired here (not deferred to main.tsx, which never
 * actually happened). The route guard only catches a 401 on NAVIGATION; a 401
 * on a mutation or background refetch (session expired mid-session) would
 * otherwise be a silent error. Admin has no local sign-in, so this bounces to
 * the portal sign-in with `?next=` back to the current admin route (14a-2). The
 * step-up variant of 401 is excluded upstream in the client middleware.
 */
export const api = createApiClient({
  baseUrl: import.meta.env['VITE_API_BASE_URL'] ?? '',
  on401: () => {
    if (typeof window === 'undefined') return;
    try {
      window.location.assign(buildSignInRedirect());
    } catch {
      // buildSignInRedirect throws only when the portal URL can't be derived
      // (SSR / bare host) — never in a real browser session. Swallow so the
      // 401 handler can't itself throw.
    }
  },
});
